import { type FC, useEffect, useRef, type ReactElement } from 'react';

import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { NftPdpZoomModalMobile } from './NftPdpZoomModalMobile';
import { NftPdpZoomModalResponsive } from './NftPdpZoomModalResponsive';
import { type Media } from '../NftPdpMedia/NftPdpMedia';
import styles from './NftPdpZoomModal.scss';

export const NftPdpZoomModal: FC<{
    isOpen: boolean;
    onClose: () => void;
    isMobile?: boolean;
    src?: string;
    onMount?: () => void;
    alt?: string;
    type: Media;
    staticImg?: ReactElement;
}> = ({ src, alt, isOpen, onClose, onMount, type, isMobile = false, staticImg }) => {
    const isMounted = useRef(false);
    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            onMount?.();
        }
    }, [onMount]);

    return (
        <ModalContainer
            modalSize="fullscreen"
            modalClass={styles.modalContainer}
            isOpen={isOpen}
            onClose={onClose}
        >
            {type === 'image' &&
                (isMobile ? (
                    <NftPdpZoomModalMobile
                        alt={alt}
                        src={src}
                        isOpen={isOpen}
                        isMobile={isMobile}
                    />
                ) : (
                    <NftPdpZoomModalResponsive alt={alt} src={src} staticImg={staticImg} />
                ))}
            {/* video is handled by browser requestFullscreen in Video.tsx */}
            <ModalCloseButton
                className={styles.modalClose}
                backgroundColor="translucentWhite"
                onClick={onClose}
            />
        </ModalContainer>
    );
};

export default NftPdpZoomModal;
